import styled from '@emotion/styled';
import { css } from '@emotion/core';

/**
 * Base wrapper for the NikeAI icon
 * Uses relative positioning to contain absolutely positioned sparkle elements
 */
export const StyledIconWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
`;

/**
 * Helper function to get sparkle positioning
 * Converts Figma positioning to CSS percentage values
 */
const getSparklePosition = position => {
  switch (position) {
    case 'sparkle1':
      return css`
        position: absolute;
        bottom: 4.17%;
        left: 10.04%;
        right: 19.12%;
        top: 25%;
      `;
    case 'sparkle2':
      return css`
        position: absolute;
        top: 4.17%;
        right: 6.62%;
        bottom: 58.33%;
        left: 55.88%;
      `;
    case 'sparkle3':
      return css`
        position: absolute;
        top: 20.83%;
        right: 69.12%;
        bottom: 62.5%;
        left: 14.21%;
      `;
    default:
      return '';
  }
};

/**
 * Container for individual sparkle elements
 * Uses percentage-based positioning for scalability
 */
export const StyledSparkleContainer = styled.div`
  ${props => getSparklePosition(props.position)}

  img,
  svg {
    display: block;
    max-width: none;
    width: 100%;
    height: 100%;
  }
`;

/**
 * Size variants for icon wrapper
 * Can be applied to parent container
 */
export const iconSizeSmall = css`
  width: var(--podium-cds-size-icon-s);
  height: var(--podium-cds-size-icon-s);
`;

export const iconSizeMedium = css`
  width: var(--podium-cds-size-icon-m);
  height: var(--podium-cds-size-icon-m);
`;

export const iconSizeLarge = css`
  width: var(--podium-cds-size-icon-l);
  height: var(--podium-cds-size-icon-l);
`;
